import {
  VARIANTS_KEY,
  VARIANTS_PATH
} from 'modules/variant/redux/state'
import logUtil from 'utils/log'
import getSelectedMediaIndexFromSelectedVariantGiftSelect from 'modules/gift/redux/selectors/get-media-index-from-selected-variant'
import updateSelectedIndexMediaGalleryAction from 'modules/media-gallery/redux/actions/update-selected-index'
import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import getShouldUpdateMediaSelect from 'modules/media-gallery/redux/selectors/get-should-update-media'
import addSelectedVariantIdToUrlProductUtil from 'modules/product/utils/add-selected-variant-id-to-url'
import getVariantIdUpdateSelectedColorVariantIdVariantActionUtil from 'modules/variant/redux/actions/update-selected-color-variant-id/utils/get-variant-id'
import getProductVariantByIdProductSelector from 'modules/product/redux/selectors/get-variant-by-id'
import isParentProductVariantUtil from 'modules/product-variant/utils/is-parent'
import updateSelectedColorVariantIdRawVariantAction from 'modules/variant/redux/actions/updated-selected-color-variant-id-raw'
import updateSelectedMediaFromVariantQuickShopAction from 'modules/quick-shop/redux/actions/update-selected-media-from-variant'

/**
 * @param props
 * @param props.variantId
 * @param props.shouldUpdateMediaGallery
 * @param props.shouldAddToUrl
 * @param props.fromSidebar
 * @param props.selectedVariantId
 * @returns {(function(*, *): void)|*}
 */
export default function updateSelectedColorVariantIdVariantAction (props) {
  return (dispatch, getState) => {
    const shouldAddToUrl = props?.shouldAddToUrl ?? true
    const shouldUpdateMediaGallery = props?.shouldUpdateMediaGallery ?? true
    const key = VARIANTS_KEY.SELECTED_COLOR_VARIANT_ID
    const fromSidebar = props?.fromSidebar ?? false
    const updateMediaGallery = props?.updateMediaGallery ?? false

    const selectedVariantIdState = (
      getVariantIdUpdateSelectedColorVariantIdVariantActionUtil({
        fromSidebar,
        variantId: props?.variantId
      })
    )
    const variantId = (
      props?.variantId ||
      selectedVariantIdState
    )
    const selectedVariantId = (
      props?.selectedVariantId ||
      variantId
    )

    const logPrefix = `variantId=${variantId} selectedVariantId=${selectedVariantId}`

    logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} [start] props=`, props)
    const shouldUpdateMedia = getShouldUpdateMediaSelect(getState())
    if (
      !shouldUpdateMedia &&
      !fromSidebar
    ) {
      logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} [noop] should not update media gallery`)
      return
    }

    const path = VARIANTS_PATH[key]
    logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} update path=${path}`)
    dispatch(
      updateSelectedColorVariantIdRawVariantAction({
        selectedVariantId: variantId
      })
    )

    if (updateMediaGallery) {
      const selectedMediaIndex = getSelectedMediaIndexFromSelectedVariantGiftSelect(getState())
      dispatch(
        updateSelectedIndexMediaGalleryAction(selectedMediaIndex)
      )
    }

    if (!variantId) {
      logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} [noop] don’t update media gallery`)
      return
    }

    if (fromSidebar) {
      addSelectedVariantIdToUrlProductUtil({
        selectedVariantId
      })
    }

    if (!shouldUpdateMediaGallery) {
      logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} [noop] should not update media gallery`)
      return
    }

    const selectedMediaIndex = getSelectedMediaIndexFromSelectedVariantGiftSelect(getState())
    logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} selectedMediaIndex=${selectedMediaIndex}`)
    if (shouldUpdateMedia) {
      dispatch(updateSelectedMediaFromVariantQuickShopAction())
    }

    if (!shouldAddToUrl) {
      return
    }

    const productVariant = getProductVariantByIdProductSelector({
      variantId
    })(getState())

    if (
      productVariant &&
      !isParentProductVariantUtil(productVariant)
    ) {
      logUtil('updateSelectedColorVariantIdVariantAction').debug(`${logPrefix} [noop] not root`)
      return
    }

    addProductAndVariantIdToUrlProductUtil({
      variantId
    })
  }
}
